import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getMachines } from 'redux/rootSelectors';
import { getMachine } from '../../../redux/machines/actions';
import MachinesDetail from './MachinesDetail';
import { useRedirectIfInvalidId } from '../../../hooks';

const ConnectedMachinesDetail = () => {
  const dispatch = useDispatch();
  const { getMachineStatus, getMachineResponse } = useSelector(getMachines);
  const { id } = useParams();

  // Redirect if id is invalid
  useRedirectIfInvalidId(id);

  const getData = useCallback(() => {
    dispatch(getMachine(id));
  }, [dispatch, id]);

  useEffect(getData, [getData]);

  return <MachinesDetail loadingState={getMachineStatus} reloadAction={getData} data={getMachineResponse} />;
};

export default ConnectedMachinesDetail;
